import React from 'react';
import { Redirect } from 'react-router-dom';
import GenericContractReleaseContainer from './Generic/ContractRelease.container';
import MarkersContractReleaseContainer from './Markers/ContractRelease.container';
import groupings from '../../Common/Constants/Groupings';
import { isNullUndefinedOrEmpty } from '../../utils';
import useGrouping from 'Common/Utils/Hooks/useGrouping';

const ContractManagementContainer = (props) => {
	document.title = "Contract Management - Release Management Menu";
	const grouping = useGrouping();
	if (isNullUndefinedOrEmpty(grouping)) {
		return <Redirect push to="/"></Redirect>;
	}

	return grouping === groupings.Marker 
		? <MarkersContractReleaseContainer grouping={grouping} {...props} /> 
		: <GenericContractReleaseContainer grouping={grouping} {...props} />;
};

export default ContractManagementContainer;
